'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStorageUtils = getStorageUtils;
exports.getStorageProxy = getStorageProxy;
exports.getWorkingLocalStorage = getWorkingLocalStorage;

var _InMemoryStorage = require('./InMemoryStorage');

var _InMemoryStorage2 = _interopRequireDefault(_InMemoryStorage);

var _SessionUtils = require('./SessionUtils');

var _SessionUtils2 = _interopRequireDefault(_SessionUtils);

var _StorageProxy = require('./StorageProxy');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var instance = new _SessionUtils2.default();

/**
 * Returns a singleton SessionUtils instance
 * @returns {SessionUtils}
 */
function getStorageUtils() {
  return instance;
}

/**
 * Function to create a storage proxy backed by a given storage implementation.
 *
 * @param storage, the internal storage implementation of the Web Storage API, default is the browser's local storage.
 * @see https://html.spec.whatwg.org/multipage/webstorage.html#the-storage-interface
 * @returns {StorageProxy} a proxy instance.
 */
function getStorageProxy() {
  var storage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : localStorage;

  return new _StorageProxy.StorageProxy(storage);
}

/**
 * @returns {StorageProxy} a proxy instance based on the best available local storage implementation.
 */
function getWorkingLocalStorage() {
  return localStorage !== undefined ? getStorageProxy() : getStorageProxy(new _InMemoryStorage2.default());
}
